module.exports = __webpack_public_path__ + "static/media/25.e793b85f.jpg";